import './TournamentTicketsDailyLimit.less';

import clsx from 'clsx';
import moment from 'moment';
import React, { FC, useEffect } from 'react';
import i18n from '../../../common/i18n';
import { Button } from '../../button/Button';
import TournamentIcon from '../../../icons/TournamentIcon';
import { LOCAL_STORAGE_TICKETS_DAILY_LIMIT } from '../constants';

const TournamentTicketsDailyLimit: FC<{
    onClose?: any;
    lastTournamentDay?: boolean;
}> = ({ onClose, lastTournamentDay }) => {
    const text = lastTournamentDay
        ? i18n('nui.tournament.daily.limit.modal.final')
        : i18n('nui.tournament.daily.limit.modal.today');
    const text2 = lastTournamentDay
        ? i18n('nui.tournament.daily.limit.modal.next')
        : i18n('nui.tournament.daily.limit.modal.tomorrow');

    useEffect(() => {
        localStorage.setItem(LOCAL_STORAGE_TICKETS_DAILY_LIMIT, moment().format('YYYY-MM-DD'));
    }, []);

    return (
        <div className="tournament-tickets-daily-limit text-center flex flex-col align-center full-width">
            <div className="flex-center tournament-logo mt-30">
                <TournamentIcon fill={'#cccccc'} width={'100px'} height={'auto'} />
            </div>
            <h1 className="mb-10 mt-20 uppercase text-extra-bold fs-16 full-width">
                {i18n('nui.tournament.daily.limit.modal.title')}
            </h1>
            <p className="fs-14 full-width c-default-light lh-21">{text}</p>
            <p className={clsx('fs-14 full-width c-default-light lh-21', { 'text-bold': !lastTournamentDay })}>
                {text2}
            </p>
            <div className="flex-center">
                <Button primary onClick={onClose} className="full-width mx-15 mb-10">
                    {i18n('nui.tournament.daily.limit.modal.button')}
                </Button>
            </div>
        </div>
    );
};

export default TournamentTicketsDailyLimit;
